<template>
  <div class="container_QuickFilter">
    <div class="containerClient_QuickFilter">
      <div id="cod-cliente-group" class="mt-1 mb-1 d-flex">
        <PFormSelect
          ref="clienteSelect"
          v-model="clienteSelected"
          :options="clientesAll"
          optionValue="id"
          optionText="codDesCliente"
          :label="$t('label.cliente')"
          :placeholder="$t('option.select')"
          variant="withoutBox"
          :disabled="!admin"
        />
      </div>
    </div>
    <div class="d-md-flex">
      <div class="itemDivisa_QuickFilter">
        <div class="itemTitle_QuickFilter">
          {{ $t("label.agruparPorDivisa") }}
        </div>
        <div class="containerButton_QuickFilter">
          <div
            :class="['button_QuickFilter', giveMeClassDivisa('todas')]"
            @click="clickDivisa('todas')"
          >
            {{ $t("label.todas") }}
          </div>
          <div
            :class="['button_QuickFilter', giveMeClassDivisa(divisa.codDivisa)]"
            v-for="divisa in getClienteXDivisa"
            :key="divisa.codDivisa"
            @click="clickDivisa(divisa.codDivisa)"
          >
            {{ divisa.codDivisa }}
          </div>
        </div>
      </div>
      <div class="itemTransaccion_QuickFilter">
        <div class="itemTitle_QuickFilter">
          {{ $t("label.transacciones") }}
        </div>
        <div class="containerButton_QuickFilter">
          <div
            :class="['button_QuickFilter', giveMeClassTipo('todas')]"
            @click="clickTipo('todas')"
          >
            {{ $t("label.todas") }}
          </div>
          <div
            :class="['button_QuickFilter', giveMeClassTipo('OFERTA')]"
            @click="clickTipo('OFERTA')"
          >
            {{ $t("label.ofertas") }}
          </div>
          <div
            :class="['button_QuickFilter', giveMeClassTipo('DEMANDA')]"
            @click="clickTipo('DEMANDA')"
          >
            {{ $t("label.demandas") }}
          </div>
        </div>
      </div>
      <PCol col="3" v-if="singleDivisaSelected">
        <div class="itemDenominacion_QuickFilter">
          <div class="itemTitle_QuickFilter">
            {{ $t("label.denominaciones") }}
          </div>
          <div class="containerButton_QuickFilter">
            <section>
              <PFormSelectMulti
                v-model="denominacionesSeleccionadas"
                :options="denominaciones"
                optionValue="id"
                optionText="desCalidadDenominacion"
                :placeholder="$t('option.select')"
                :scroll="true"
                :showTextOver="true"
              />
            </section>
            <b-form-text
              v-if="denominacionesSeleccionadas.length"
              v-text="$t(`message.denomination.disabled`)"
            />
          </div>
        </div>
      </PCol>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ICalidadDenominacion, ICliente, IClienteAll, IDivisa } from "@/entities";
import {
  iniQuickFilter,
  IQuickFilter,
  ITransferenciasQuickFilter,
} from "@/pages/transferencias/types";
import { todosClienteAll } from "@/constans";
import VueMethods from "@/vue-methods";

@Component({
  mixins: [VueMethods],
})
export class QuickFilter extends Vue {
  @Prop({ required: true }) value!: IQuickFilter;
  valueLocal: IQuickFilter = iniQuickFilter;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    if (this.value) this.valueLocal = JSON.parse(JSON.stringify(this.value));
  }
  @Watch("getClienteXDivisa", { immediate: true, deep: true })
  onClienteXDivisaChange(newDivisas: IDivisa[]) {
    this.resetDenominaciones();
    if (!newDivisas || !newDivisas.length) {
      return;
    }
    if (newDivisas.length === 1) {
      const divisa = newDivisas[0];
      this.valueLocal.divisas = [divisa.codDivisa];
      this.loadDenominaciones(divisa);
    } else {
      this.valueLocal.divisas = newDivisas.map((d) => d.codDivisa);
    }
  }

  @Getter("getTransferenciasPageQuickFilter")
  getTransferenciasPageQuickFilter!: ITransferenciasQuickFilter;
  @Getter("getClienteXDivisa") getClienteXDivisa!: IDivisa[];
  @Getter("getClientesAll") getClientesAll!: IClienteAll[];
  @Getter("getClienteSelected") getClienteSelected!: ICliente;

  @Action("setClienteSelected") setClienteSelected!: (cliente?: ICliente) => Promise<void>;
  @Action("setTransferenciasPageQuickFilter") setTransferenciasPageQuickFilter!: (
    filter: ITransferenciasQuickFilter
  ) => void;

  @Ref("clienteSelect") clienteSelect: any;

  private admin = false;
  private optionTodos: IClienteAll = todosClienteAll;
  denominacionesSelected: number[] = [];
  denominaciones: ICalidadDenominacion[] = [];

  async mounted(): Promise<void> {
    this.admin = this.getClientesAll.length > 1;
  }

  openSelectClientes(): void {
    this.clienteSelect.pussOption = true;
  }

  giveMeClassDivisa(divisa: string): string {
    //recoremos todos a ver si estan seleccionados
    let allSelected = true;
    this.getClienteXDivisa.forEach((value) => {
      if (this.valueLocal.divisas.findIndex((div) => div === value.codDivisa) < 0) {
        allSelected = false;
      }
    });
    if (allSelected && divisa === "todas") {
      return "buttonSelected_QuickFilter";
    } else if (!allSelected) {
      const indexSelectedDivisa = this.valueLocal.divisas.findIndex((div) => div === divisa);
      if (indexSelectedDivisa > -1) {
        return "buttonSelected_QuickFilter";
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  giveMeClassTipo(tipoId: string): string {
    let allSelected = true;
    //si no encontramos alguno es que no estan selecionados
    if (this.valueLocal.tipos.findIndex((tip) => tip === "OFERTA") < 0) {
      allSelected = false;
    }
    if (this.valueLocal.tipos.findIndex((tip) => tip === "DEMANDA") < 0) {
      allSelected = false;
    }
    if (allSelected && tipoId === "todas") {
      return "buttonSelected_QuickFilter";
    } else if (!allSelected) {
      const indexSelectedtipo = this.valueLocal.tipos.findIndex((tipId) => tipId === tipoId);
      if (indexSelectedtipo > -1) {
        return "buttonSelected_QuickFilter";
      } else {
        return "";
      }
    } else {
      return "";
    }
  }

  get clientesAll(): Partial<IClienteAll>[] {
    const clientes: Partial<IClienteAll>[] = Object.assign([], this.getClientesAll);

    if (this.admin) {
      clientes.unshift(this.optionTodos);
    }

    return clientes;
  }

  get clienteSelected(): number {
    let cliente = this.getClienteSelected;
    return (cliente?.id ?? this.valueLocal.cliente) || -1;
  }

  set clienteSelected(clienteId: number) {
    if (clienteId && clienteId !== -1) {
      this.setClienteSelected(
        this.clientesAll.find((cliente) => cliente.id === clienteId) as ICliente
      );
    } else {
      this.setClienteSelected();
    }

    this.valueLocal.cliente = clienteId;
    this.$emit("input", this.valueLocal);
    this.$emit("change", { action: "quickFilter_cliente", data: this.valueLocal });
  }

  clickDivisa(divisaSelected: string): void {
    let allSelected = true;
    this.getClienteXDivisa.forEach((divisa) => {
      if (this.valueLocal.divisas.findIndex((div) => div === divisa.codDivisa) < 0) {
        allSelected = false;
      }
    });
    if (divisaSelected === "todas") {
      this.valueLocal.divisas = [];
      this.getClienteXDivisa.forEach((divisa) => {
        this.valueLocal.divisas.push(divisa.codDivisa);
      });
      //seleccionamos todos
    } else if (allSelected) {
      //si pasamos de todos a seleccionar solo uno
      this.valueLocal.divisas = [];
      this.valueLocal.divisas.push(divisaSelected);
    } else {
      const divisaSeleccionada = this.getClienteXDivisa.find(
        (divisa) => divisa.codDivisa === divisaSelected
      );
      const indexSelectedDivisa = this.valueLocal.divisas.findIndex(
        (divisaId) => divisaId === divisaSelected
      );
      if (indexSelectedDivisa > -1) {
        //como exite la quitamos
        this.valueLocal.divisas.splice(indexSelectedDivisa, 1);
        if (!this.valueLocal.divisas.length) {
          this.getClienteXDivisa.forEach((divisa) => {
            this.valueLocal.divisas.push(divisa.codDivisa);
          });
        }
      } else if (divisaSeleccionada) {
        //como no exite lo Añadiremos
        this.valueLocal.divisas.push(divisaSeleccionada.codDivisa);
      }
    }

    if (this.singleDivisaSelected) {
      const divisa = this.getClienteXDivisa.find((d) => d.codDivisa === this.valueLocal.divisas[0]);
      if (divisa) {
        this.loadDenominaciones(divisa);
      } else {
        this.resetDenominaciones();
      }
    } else {
      this.resetDenominaciones();
    }

    this.$emit("input", this.valueLocal);
    this.$emit("change", { action: "quickFilter_divisa", data: this.valueLocal });
  }

  get singleDivisaSelected(): boolean {
    return !!this.getClienteSelected?.id && this.valueLocal.divisas.length === 1;
  }

  resetDenominaciones(): void {
    this.denominaciones = [];
    this.denominacionesSeleccionadas = [];
    this.valueLocal.denominaciones = [];
  }

  async loadDenominaciones(divisa: IDivisa): Promise<void> {
    const response = await this.$services.clientes.fetchCalidadDenominacionesCliente({
      idCliente: this.clienteSelected,
      idDivisa: divisa.id,
    });

    this.denominaciones = (response ?? [])
      .map((d) => ({
        ...d,
        desCalidadDenominacion: `${d.denominacion?.codDenominacion ?? ""} ${
          d.desCalidad ?? ""
        }`.trim(),
      }))
      .filter((d) => d.desCalidadDenominacion)
      .sort((a, b) => this.sortAscending(a, b, "desCalidadDenominacion"));
  }

  get denominacionesSeleccionadas(): number[] {
    return this.denominacionesSelected;
  }

  set denominacionesSeleccionadas(newVal: number[]) {
    this.denominacionesSelected = newVal;
    this.valueLocal.denominaciones = [...newVal];
    this.$emit("input", this.valueLocal);
    this.$emit("change", { action: "quickFilter_denominaciones", data: this.valueLocal });
  }

  clickTipo(tipoSelected: "todas" | "OFERTA" | "DEMANDA"): void {
    let allSelected = true;
    //sino encontramos alguno esque no estan selecionados
    if (this.valueLocal.tipos.findIndex((tip) => tip === "OFERTA") < 0) {
      allSelected = false;
    }
    if (this.valueLocal.tipos.findIndex((tip) => tip === "DEMANDA") < 0) {
      allSelected = false;
    }
    if (tipoSelected === "todas") {
      this.valueLocal.tipos = [];
      this.valueLocal.tipos.push("OFERTA");
      this.valueLocal.tipos.push("DEMANDA");

      //seleccionamos todos
    } else if (allSelected) {
      //sipasamos de todos a seleccionar solo uno
      this.valueLocal.tipos = [];
      this.valueLocal.tipos.push(tipoSelected);
    } else {
      const indexSelectedtipo = this.valueLocal.tipos.findIndex(
        (tipoId) => tipoId === tipoSelected
      );
      if (indexSelectedtipo > -1) {
        //como existe la quitamos
        this.valueLocal.tipos.splice(indexSelectedtipo, 1);
        if (!this.valueLocal.tipos.length) {
          this.valueLocal.tipos.push("OFERTA");
          this.valueLocal.tipos.push("DEMANDA");
        }
      } else {
        //como no existe lo Añadiremos
        this.valueLocal.tipos.push(tipoSelected);
      }
    }
    this.$emit("input", this.valueLocal);
    this.$emit("change", { action: "quickFilter_tipo", data: this.valueLocal });
  }
}

export default QuickFilter;
</script>
<style lang="scss" scoped>
.container_QuickFilter {
  padding: 0.4rem 0;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.itemTransaccion_QuickFilter {
  @media (min-width: 768px) {
    margin-right: 2em;
    padding-left: 2em;
  }
}

.itemDivisa_QuickFilter {
  padding-bottom: 10px;

  @media (min-width: 768px) {
    padding-right: 2em;
    border-right: 3px solid #e9e9e9;
    max-width: calc(100vw - 620px);
    min-width: 200px;
  }

  .button_QuickFilter {
    width: 68px;
  }
}

.itemDenominacion_QuickFilter {
  @media (min-width: 768px) {
    padding-left: 2em;
    border-left: 3px solid #e9e9e9;
    max-width: calc(100vw - 620px);
    min-width: 200px;
  }
}

.containerClient_QuickFilter {
  width: 100%;
  margin-bottom: 15px;
}

.itemTitle_QuickFilter {
  font-size: 12px;
  line-height: 1.33;
  color: #979797;
  padding: 0 0 0.3rem 0;
  width: 150px;
}

.containerButton_QuickFilter {
  display: block;
}

.button_QuickFilter {
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  padding: 0.15rem 1rem;
  border-radius: 50rem;
  color: var(--secundario-prosegur-oscuro);
  background-color: var(--fondo-not-active-toggle);
  border-color: var(--fondo-not-active-toggle);
  margin-right: 0.5rem;
  cursor: pointer;
  display: inline-block;
}
.buttonSelected_QuickFilter {
  font-weight: 500;
  background-color: var(--amarillo-prosegur);
  border-color: var(--amarillo-prosegur);
}
</style>
